
import { Vue, Component, Prop } from 'vue-property-decorator'
import setting from '@/settings'

@Component({
  name: 'preview-base'
})

export default class PreviewBase extends Vue {
  private setting = setting
  private imageClass = ['single', 'double', 'three', 'four']

  // 基础信息
  @Prop({ type: Object })
  private data!: {}|any

  // 简章信息
  @Prop({ type: Array })
  private instrs!: []

  get labels () {
    return this.data.labelName ? this.data.labelName.split(',') : []
  }
}
